import pkg from '../../package.json'

export const VERSION = pkg.version

export const ENVIRONMENT = process.env.ENV as string

export const FALLBACK_CLIENT = process.env.NEXT_PUBLIC_FALLBACK_CLIENT as string
export const RETAILER_JSON_URL = process.env.NEXT_PUBLIC_JSON_URL as string
export const RETAILER_URLS = process.env.CLIENTS_URLS as string

export const PICK_AND_COLLECT = 'PICK_AND_COLLECT'
export const DELIVERY = 'DELIVERY'

export const IS_PRODUCTION = process.env.ENV === 'production'
export const SECOND_TO_MS = 1_000

export const APOLLO_URI_DEADPOOL_V3 = process.env
  .NEXT_PUBLIC_DB_DEADPOOL_V3 as string
export const APOLLO_URI_DEADPOOL_V2 = process.env
  .NEXT_PUBLIC_DB_DEADPOOL_V2 as string

export const LIVE_TRACKER_URL = process.env
  .NEXT_PUBLIC_LIVE_TRACKER_URL as string

export const SCROLL_TOP_THRESHOLD = 500

export const STORE_REF_ID_SEPARATOR = '__'

export const DEFAULT_TOKEN_STORE_DAYS = 5
export const DEFAULT_COOKIE_STORE_DAYS = 1
export const IS_ENV = process.env.NEXT_PUBLIC_ENV
export const IS_PRODUCTION_ENV =
  process.env.NEXT_PUBLIC_ENV === 'production' ||
  process.env.NEXT_PUBLIC_ENV === 'sailfish'

export const IS_EUROPE = process.env.NEXT_PUBLIC_NODE_ENV === 'sailfish'
export const IS_AMERICA = process.env.NEXT_PUBLIC_NODE_ENV === 'production'

export const SEARCH_AGGREGATES = {
  orderBy: 'orderBy',
  priceRanges: 'priceRanges',
  tags: 'tags',
  availablePromotions: 'availablePromotions',
  categories: 'categories',
  brands: 'brands',
  isAvailable: 'isAvailable',
  sort: 'sort',
  operationalModels: 'operationalModels',
}

export const SPLIT_BY = '~~'

export const SUPPORTED_SEARCH_LANGUAGES = ['ES', 'EN']

export const PAGINATION_SIZE_SEARCH = 50

export const FILTERS_ICONS = {
  priceRanges: 'ph-currency-dollar-simple',
  categories: 'ph-squares-four',
  availablePromotions: 'ph-gift',
  tags: 'ph-tag',
  brands: 'ph-seal-check',
  operationalModels: 'ph-truck',
}

export const FIVE_MINUTES_MS = 5 * 60 * 1000
export const FIFTEEN_MINUTES_MS = 15 * 60 * 1000

export const DEFAULT_CACHE_LIFETIME_IN_MS = IS_PRODUCTION
  ? FIFTEEN_MINUTES_MS
  : FIVE_MINUTES_MS

export const COOKIE_CLIENT_ID = '_IL-clientId'
export const COOKIE_APP_HYBRID = '_IL-app-hybrid'
export const COOKIE_APP_HYBRID_VERSION = '_IL-app-hybrid-version'
export const COOKIE_SSR_PAGES = '_IL-ssr-pages'
export const HEADER_MOIRA = 'x-moira'
export const HEADER_CLIENT_ID = 'x-client-id'
